"use strict";
////////////////////////////////////////////////
// ChartType
////////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleChartSettingsJSONModel = exports.ChartType = void 0;
var ChartType;
(function (ChartType) {
    ChartType["classicWithPercents"] = "classicWithPercents";
    ChartType["classicWithCounters"] = "classicWithCounters";
    ChartType["quickRatio"] = "quickRatio";
    ChartType["overtime"] = "overtime";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
class LifecycleChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetChartType();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.chartType = validateChartType(serializedState.chartType);
            }
        };
        this.serialize = () => {
            return {
                chartType: this.chartType,
            };
        };
        ////////////////////////////////////////////////
        // ChartType
        ////////////////////////////////////////////////
        this.getChartType = () => this.chartType;
        this.setChartType = (value) => {
            this.chartType = validateChartType(value);
        };
        this.resetChartType = () => this.setChartType(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.LifecycleChartSettingsJSONModel = LifecycleChartSettingsJSONModel;
LifecycleChartSettingsJSONModel.getDefaultModel = () => {
    return new LifecycleChartSettingsJSONModel().serialize();
};
const validateChartType = (value) => {
    if (typeof value === "string" && value in ChartType) {
        return value;
    }
    return ChartType.classicWithCounters;
};
